<script lang="ts">
  import { getModalStore, getToastStore } from '@skeletonlabs/skeleton'
  import type { SvelteComponent } from 'svelte'

  import CloseModalButton from './CloseModalButton.svelte'
  import Input from './Input.svelte'

  interface Props {
    /** Exposes parent props to this component. */
    parent: SvelteComponent
  }

  let { parent }: Props = $props()

  let approveTest = $state('')

  const toastStore = getToastStore()
  let activeToast: string | null = null

  const onFormCancel = () => {
    if ($modalStore[0].response) {
      $modalStore[0].response(false)
    }
    modalStore.close()
  }
  const onFormSubmit = () => {
    if (activeToast) {
      toastStore.close(activeToast)
    }
    if (singleItemToApprove) {
      if (approveTest != $modalStore[0].meta) {
        activeToast = toastStore.trigger({
          message: "You didn't type the name of the item correctly",
          background: 'variant-filled-error',
        })
        return
      }
    } else {
      if (approveTest != 'APPROVE') {
        activeToast = toastStore.trigger({
          message: "You didn't type APPROVE correctly",
          background: 'variant-filled-error',
        })
        return
      }
    }
    if ($modalStore[0].response) {
      $modalStore[0].response(true)
    }
    modalStore.close()
  }

  const modalStore = getModalStore()

  const singleItemToApprove = typeof $modalStore[0].meta == 'string'
</script>

{#if $modalStore[0]}
  <div class="card w-modal space-y-4 p-4 shadow-xl" role="dialog">
    <h3 class="h3 sticky top-0 justify-between bg-surface-50 p-4 dark:bg-surface-800">
      {$modalStore[0].title}<CloseModalButton onClose={parent.onClose} />
    </h3>
    <article class="space-y-4 p-4">
      {$modalStore[0].body}
      {#if singleItemToApprove}
        <pre>{$modalStore[0].meta}</pre>
      {:else}
        <ol class="list my-3">
          {#each $modalStore[0].meta as meta, number (meta)}
            <li>
              <span class="variant-soft-primary badge-icon p-4">{number + 1}.</span>
              <span class="flex-auto overflow-x-hidden"><pre>{meta}</pre></span>
            </li>
          {/each}
        </ol>
      {/if}
      {#if singleItemToApprove}
        <p>Please confirm you want to approve this run by typing the name of the item</p>
        <Input type="text" bind:value={approveTest} />
      {:else}
        <p>Please confirm you want to approve these run by typing "APPROVE"</p>
        <Input type="text" bind:value={approveTest} />
      {/if}
    </article>
    <footer class="modal-footer {parent.regionFooter}">
      <button class="btn {parent.buttonNeutral}" onclick={onFormCancel}
        >{parent.buttonTextCancel}</button
      >
      <button class="btn {parent.buttonPositive}" onclick={onFormSubmit}
        >{parent.buttonTextConfirm}</button
      >
    </footer>
  </div>
{/if}
